<template>
  <div class='h-mml-xybox'>
    <p style='padding:0px;margin:0px;'><pre>{{msgContent()}}</pre></p>
  </div>
</template>

<script>
export default {
  name: 'ShowMsgContent',
  props: {
    resp: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    msgContent() {
      const data = this.resp.datas[this.resp.datas.length-1];
      const msg = data ? data.Data : this.resp.data.Data;
      return msg && msg[0] ? msg[0].MessageContent : '';
    }
  }
};
</script>

<style>

</style>